import MarkdownIt from 'markdown-it';
import { MarkdownParser, MarkdownSerializer, } from 'prosemirror-markdown';
export var createMarkdownTransformer = function (schema, nodes, marks, tokens, options) {
    var tokenizer = new MarkdownIt();
    var parser = new MarkdownParser(schema, tokenizer, tokens);
    var serializer = new MarkdownSerializer(nodes, marks);
    return {
        parse: function (markdown) {
            return parser.parse(markdown);
        },
        serialize: function (doc) {
            return serializer.serialize(doc, options);
        },
    };
};
